import { mapPartners } from '@/components/partners/partner'
import { Partner } from '@/types/partner'

export const FINANCE_PARTNERS: Partner[] = [
  {
    id: 'pm-gautron',
    name: 'Pierre-Marie GAUTRON',
    type: 'finance',
    logo: '/partners/meilleur-taux/meilleur-taux-logo.png',
    logoW: 150,
    logoH: 150,
    website: {
      fr: 'https://www.meilleurtaux.com/a-propos-de-meilleurtaux/toutes-nos-agences-en-france/courtier-paris-6.html',
      en: 'https://www.meilleurtaux.com/a-propos-de-meilleurtaux/toutes-nos-agences-en-france/courtier-paris-6.html'
    },
    email: 'pm.gautron@meilleurtaux.com',
    phone: '+33 6 61 96 69 93',
    location: {
      fr: 'Paris 6',
      en: 'Paris 6'
    },
    addresses: [
    ],
    description: {
      fr: 'Agence de Courtage en crédit',
      en: 'Mortgage brokerage agency'
    },
    title: {
      fr: 'Directeur d\'agence',
      en: 'Agency Director'
    }
  },
  {
    id: 'y-beltramone',
    name: 'Yoann BELTRAMONE',
    type: 'finance',
    logo: '/partners/meilleur-taux/meilleur-taux-logo.png',
    logoW: 150,
    logoH: 150,
    website: {
      fr: 'https://www.meilleurtaux.com/a-propos-de-meilleurtaux/toutes-nos-agences-en-france/courtier-antibes.html',
      en: 'https://www.meilleurtaux.com/a-propos-de-meilleurtaux/toutes-nos-agences-en-france/courtier-antibes.html'
    },
    email: 'y.beltramone@meilleurtaux.com',
    phone: '+33 6 07 29 54 64',
    location: {
      fr: 'Antibes - Sophia Antipolis',
      en: 'Antibes - Sophia Antipolis'
    },
    addresses: [
    ],
    description: {
      fr: 'Agence de Courtage en crédit',
      en: 'Mortgage brokerage agency'
    },
    title: {
      fr: 'Directeur d\'agence',
      en: 'Agency Director'
    }
  }
]
export const FINANCE_PARTNERS_MAP: {[partnerId: string]: Partner} = mapPartners(FINANCE_PARTNERS)